import styles from './styles.module.css'

type SkeletonFeedProps = {
  index: number
}

const SkeletonFeed: React.FC<SkeletonFeedProps> = () => {
  return (
    <div className={`${styles.skeleton__feed__container}`}>
      <div className={`${styles.skeleton__feed__head__avatar__desk}`}></div>
      <div className={styles.skeleton__feed__wrapper}>
        <div className={styles.skeleton__feed__head}>
          <div className={styles.skeleton__feed__head__avatar}></div>
          <div className={styles.skeleton__feed__head__content}>
            <div />
            <div className="md:hidden" />
          </div>
        </div>
        <div className={styles.skeleton__feed__head__description}>
          <div />
          <div />
        </div>
        <div className={styles.skeleton__feed__head__image}></div>
        <div className={styles.skeleton__feed__head__footer}>
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  )
}

export default SkeletonFeed
